<template>
  <v-app id="login" class="blue darken-2">
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4 lg4>
          <v-card class="elevation-4 pa-6">
            <v-card-text>
              <div class="layout column align-center pa-1 ma-3">
                <img src="../assets/images/logo.png" alt="Vue Material Admin" width="250" height="150" />
              </div>
              <v-form ref="form">
                <v-text-field
                  v-model="login.usuario"
                  label="Usuario"
                  :rules="fieldRequired"
                  required
                  dense/>
                <v-text-field
                  v-model="login.password"
                  label="Contraseña"
                  :append-icon="showeye ? 'visibility' : 'visibility_off'"
                  :append-icon-cb="() => (value = !value)"
                  :rules="fieldRequired"
                  required
                  :type="showeye ? 'text' : 'password'"
                  @click:append="showeye = !showeye"
                  @keyup.enter="loginAccess"
                />
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn :disabled="!valid" color="success"  @click="loginAccess">Login</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { Validate } from '@/mixins/validateFormMixin'
import router from '@/router'
export default {
  name: 'login',
  mixins: [Validate],
  props: {
    source: String
  },
  data: () => ({
    valid: true,
    showeye: false,
    loger: null,
    login: {
      usuario: '',
      password: ''
    }
  }),
  mounted () {
  },
  methods: {
    loginAccess () {
      if (this.$refs.form.validate()) {
        this.getUrl('usr.login')
      } else {

      }
    },
    ...mapActions(['getUrlServices', 'postUrlServiceLoginAction']),
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postUrlServiceLoginAction({ url: router, data: this.login })
      } else {
        this.getUrlServices()
      }
    },
    ...mapMutations([])
  },
  computed: {
    ...mapGetters(['get_urls', 'get_object'])
  },
  watch: {
    get_urls (vals) {
      this.getUrl('usr.login')
    },
    get_object (val) {
      if (val) {
        if (val.message) {
          this.$swal({
            type: 'error',
            icon: 'error',
            title: 'Error!',
            text: val.message
          })
          return
        }
        this.$cookies.set('token', val.access_token)
        localStorage.setItem('permisos', JSON.stringify(val.user.roles[0]))
        localStorage.setItem('user', JSON.stringify(val.user))
        router.push({ name: 'home' })
      }
    }
  }
}
</script>

<style scoped lang="css">
  #login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }
  .verde{
    background: #009B37;
  }
</style>
